export const MODERATION = 'moderation';
export const WORKSPACE = 'workspace';
export const WORKSPACES = 'workspaces';
export const NEW_WORKSPACE = 'new_workspace';
export const CREATE_QUEUE = 'create_queue';
export const QUEUE = 'queue';
export const NEW_QUEUE = 'new_queue';
export const SEARCH = 'search';
export const NEW_SEARCH = 'new_search';
export const QUICK_SEARCH = 'quick_search';
export const NOT_FOUND = 'not_found';
